/**
 * Announcement component.
 * @module components/View/Announcement
 */
import React from 'react';
import { hasBlocksData } from '@plone/volto/helpers';
import { Container, Grid } from 'semantic-ui-react';
import { FormattedMessage, defineMessages } from 'react-intl';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Map } from '../';


const AnnouncementView = (props) => {
  const { content } = props;

  const getPosition = function (geolocation) {
    if (! geolocation ) {
      return null
    }
    return geolocation.split(';').map(parseFloat);
  }

  const geolocation = getPosition(content.geolocation)

  return (
    <>
      <Container>
        {geolocation && (
          <>
            <Map marker={geolocation} center={geolocation} />
          </>
        )}

        {/* Volto Blocks */}
        {hasBlocksData(content) ? (
          <div className="userBlocks">
            <RenderBlocks {...props} />
          </div>
        ): null}

      </Container>

    </>
  );
};

export default AnnouncementView;